import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=1a9a6854&"
import script from "./Personnel.vue?vue&type=script&lang=js&"
export * from "./Personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports